import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

let getAccessTokenSilentlyFn: (() => Promise<string>) | null = null;
let logoutFn: (() => Promise<void>) | null = null;

export const setupAxiosInterceptors = (
  getAccessTokenSilently: () => Promise<string>,
  logout: () => Promise<void>
) => {
  getAccessTokenSilentlyFn = getAccessTokenSilently;
  logoutFn = logout;

  axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          if (getAccessTokenSilentlyFn) {
            const token = await getAccessTokenSilentlyFn();
            
            if (originalRequest.headers) {
              originalRequest.headers.Authorization = `Bearer ${token}`;
            }
            
            return axios(originalRequest);
          }
        } catch (refreshError) {
          console.error('Token refresh failed, logging out user:', refreshError);
          
          if (logoutFn) {
            await logoutFn();
          }
          
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );
};
